import { useState } from "react";
import UserIcon from "../../assets/profile.png";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import Modal from "../Reusable/Modal";
import ChangePassword from "./ChangePassword";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import { responsiveClassName } from "../../utils/classNames";
import TextField from "../Reusable/TextInput";
import { createUserValidationForm } from "../../utils/validationSchemas";

const CurrentUserProfile = (props: any) => {
  const { profile, userProfileType } = props;
  const [openChangePasswordPopup, setOpenChangePasswordPopup] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: async () => {
      return {
        full_name: profile?.name,
        email: profile?.email,
        username: profile?.username,
        mobile_number: profile?.mobile_number,
        alt_mobile_number: profile?.profile?.contact_number ?? null,
        alt_email: profile?.profile?.email ?? null,
      };
    },
    //@ts-ignore
    resolver: yupResolver(createUserValidationForm),
  });
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["users"],
    navigateURL: "",
  });
  const handleUpdateProfile = async (values: any, setError: any) => {
    const url = `${APIS.USER}${profile?.id}/update-profile/`;
    let formData = {
      ...values,
      alt_email: values?.alt_email ? values?.alt_email : null,
      alt_mobile_number: values?.alt_mobile_number
        ? values?.alt_mobile_number
        : null,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <Card>
        <div className={tw`m-2`}>
          <div className={tw`flex flex-row  items-center justify-between`}>
            <div
              className={tw`flex flex-row gap-x-2 items-center justify-center`}
            >
              <img
                src={UserIcon}
                alt="User Icon"
                className={tw`cursor-pointer h-16 w-16`}
              />
              <div>
                <p> {profile?.name}</p>
                <p>
                  <span className={tw`block`}>
                    {profile?.is_superuser
                      ? "Super Admin"
                      : userProfileType?.is_rider
                      ? "Rider"
                      : userProfileType?.is_merchant
                      ? "Merchant"
                      : userProfileType?.is_staff
                      ? "Staff"
                      : "N/A"}
                  </span>
                </p>
                <span className={tw`block cursor-pointer`}>
                  {profile?.default_branch?.name?.length
                    ? profile?.default_branch?.name
                    : "N/A"}
                  -
                  {profile?.default_branch?.landmark?.length
                    ? profile?.default_branch?.landmark
                    : "N/A"}
                </span>
              </div>
            </div>

            <div className={tw`w-[150px] mt-6`}>
              <Button
                label={"Change Password"}
                onClick={() =>
                  setOpenChangePasswordPopup(!openChangePasswordPopup)
                }
              />
            </div>
          </div>
          <form
            className={tw`mt-10`}
            onSubmit={handleSubmit((data) =>
              handleUpdateProfile(data, setError)
            )}
          >
            <div>Personal Information</div>
            <div
              className={responsiveClassName(
                "grid-cols-1 grid",
                "grid grid-cols-2 gap-x-6"
              )}
            >
              <TextField
                label={"Name"}
                register={register("full_name")}
                errors={errors?.full_name}
              />
              <TextField
                label={"Username"}
                register={register("username")}
                errors={errors?.username}
              />
              <TextField
                label={"Email"}
                register={register("email")}
                errors={errors?.email}
              />
              <TextField
                label={"Alt Email"}
                register={register("alt_email")}
                errors={errors?.alt_email}
              />
              <TextField
                label={"Phone"}
                register={register("mobile_number")}
                errors={errors?.mobile_number}
              />
              <TextField
                label={"Alt Phone no."}
                register={register("alt_mobile_number")}
                errors={errors?.alt_mobile_number}
              />
            </div>
            <div className={tw`w-full flex justify-end`}>
              <div className={tw`w-32`}>
                <Button label={"Update"} isLoading={isPostLoading} />
              </div>
            </div>
          </form>
        </div>
      </Card>
      <Modal
        isOpen={openChangePasswordPopup}
        setIsOpen={setOpenChangePasswordPopup}
        title={"Change Password"}
        children={
          <>
            <ChangePassword
              profile={profile}
              setOpenChangePasswordPopup={setOpenChangePasswordPopup}
            />
          </>
        }
      />
    </>
  );
};

export default CurrentUserProfile;
